<div>
  <app-page-breadcrumb pageTitle="From Elements" />
  <div class="grid grid-cols-1 gap-6 xl:grid-cols-2">
    <div class="space-y-6">
      <div><app-default-inputs/></div>
      <div><app-select-inputs/></div>
      <div><app-text-area-input/></div>
      <div><app-input-states/></div>
    </div>
    <div class="space-y-6">
      <div><app-input-group/></div>
      <div><app-file-input-example/></div>
      <div><app-checkbox-components/></div>
      <div><app-radio-buttons/></div>
      <div><app-toggle-switch/></div>
      <div><app-dropzone/></div>
    </div>
  </div>
</div>